import React, { Component } from 'react';
import { Modal, Input, Radio, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class ReuseApprove extends Component {
    state = {
        record: {},
        invList: [],
        saveParams: {},
        visible: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
            saveParams: {},
        }, () => {
            this.checkJdeMainCode();
        });
    }

    cancel = () => {
        this.setState({ visible: false });
    }

    checkJdeMainCode = () => {
        const { record: { afterAlterContractId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.contract.checkJdeMainCode,
            data: { afterAlterContractId },
            dataType: 'json',
            doneResult: res => {
                const { invNames } = res;
                this.setState({ invList: invNames });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { record: { jdeMainApplyId }, saveParams } = this.state;
        const {
            approvalStatus,
            comments,
        } = saveParams;
        if (!approvalStatus) {
            message.warning('请选择复用审批结论');
            return;
        }
        if (approvalStatus == 'DISAGREE' && !comments) {
            message.warning('请输入不同意原因');
            return;
        }
        this.setState({ loading: true });
        let url = API_URL.contract.boMultiplexApproval;
        const options = {
            method: 'post',
            url,
            data: {
                jdeMainApplyId,
                ...saveParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    render () {
        const { visible, record, invList, saveParams } = this.state;
        const { investigationName, afterAlterContractCode } = record;
        const { approvalStatus, comments } = saveParams;
        const radioStyle = {
            display: 'block',
            paddingLeft: 10,
            height: 30,
            lineHeight: '30px',
        };
        return (
            <Modal
                title="JDE主项目号复用审批"
                visible={visible}
                onOk={this.submit}
                onCancel={this.cancel}
                wrapClassName="vertical-center-modal"
                width="460px"
            >
                <div style={{ padding: '10px 20px', whiteSpace: 'initial' }}>
                    <div style={{ marginBottom: 8 }}>
                        是否允许项目【{investigationName}】的JDE主项目号变更申请【{afterAlterContractCode}】?
                    </div>
                    <div style={{ margin: '8px 0', color: '#999' }}>
                        已使用该JDE主项目号的项目：{ invList.map((item, index) => `【${item}】${index === invList.length - 1 ? '' : '、'}`)}
                    </div>
                    <Radio style={radioStyle} value='AGREE' checked={approvalStatus === 'AGREE'} onChange={e => this.handleInputChange(e, 'approvalStatus')}>同意</Radio>
                    <Radio style={radioStyle} value='DISAGREE' checked={approvalStatus === 'DISAGREE'} onChange={e => this.handleInputChange(e, 'approvalStatus')}>不同意</Radio>
                    {
                        approvalStatus == 'DISAGREE' &&
                        <div style={{paddingLeft: 30}}>
                            <Input
                                placeholder="请输入不同意原因"
                                style={{width: 240 }}
                                value={comments}
                                onChange={e => this.handleInputChange(e, 'comments')}
                            />
                        </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default ReuseApprove;


// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/ReuseApprove.js